import * as policies from "../../policies/index.js";
import { useUser } from "@accredo/fe-shared/hooks/user.js";

export function useAbility() {
  const { user } = useUser();

  function can(domain, action, context = {}) {
    if (!user) {
      console.log("No user found");
      return false;
    }

    const policyDomain =
      domain.charAt(0).toUpperCase() + domain.slice(1) + "Policy";
    const policy = policies[policyDomain];

    if (!policy) {
      console.error(`No policy found for domain: ${policyDomain}`);
      return false;
    }

    const rule = policy[action];

    if (!rule) {
      console.error(`No action "${action}" in policy "${policyDomain}"`);
      return false;
    }
    return rule({ ...context, user });
  }

  return { can };
}
